import axios from  "axios";
import { secureApiCall } from "./authHeader"; 
import { authHeaderSms } from './authHeader';

 const API_URL = process.env.REACT_APP_BACKEND_URL;

if (!API_URL) {
   console.error("Error: REACT_APP_BACKEND_URL no está definido.");
}


export const createAsesores = async (asesoresData) => {
    try {
        const requestPayload = {
            body: {
                dni: asesoresData.dni,
                operadorId: asesoresData.operadorId,
                telefono: asesoresData.telefono,
                correo: asesoresData.correo, 
                codigoCliente: asesoresData.codigoCliente,
                consentimientoCliente1: asesoresData.consentimientoCliente1 ?? 1,
                consentimientoCliente2: asesoresData.consentimientoCliente2 ?? 1,
                codigoAsesor: asesoresData.codigoAsesor,
                canalId: asesoresData.canalId,
                consentimiento1: asesoresData.consentimiento1,
                consentimiento2: asesoresData.consentimiento2,
                captcha: asesoresData.captcha,

                //utm
                URL_UTM: asesoresData.URL_UTM,
                UTM_SOURCE: asesoresData.UTM_SOURCE,
                UTM_MEDIUM: asesoresData.UTM_MEDIUM,
                UTM_CAMPAIGN: asesoresData.UTM_CAMPAIGN,
                UTM_TERM: asesoresData.UTM_TERM,
                UTM_CONTENT: asesoresData.UTM_CONTENT
            }
        };
        const response = await secureApiCall("api/v1/Asesores/Crear", "post", requestPayload);
        return response;        
    } catch (error) {
        console.error('Error en createAsesores:', error.response?.data || error.message);
        throw error;
    }
};

export const seleccionarCanal = async() => {    
    try {        

        const response = await secureApiCall("api/v1/Asesores/SeleccionarCanal", "get");
        return response;
        
    } catch (error) {
        console.error('Error en seleccionarCanal:', error.response?.data || error.message);
        throw error;
    }
};

//Endpoint de Asesores-Operadores
export const seleccionarOperadores = async() => {
  try {
      const response = await secureApiCall("api/v1/Asesores/SeleccionarOperadores", "get");
        return response;
  } catch (error) {
        console.error('Error en seleccionarOperadores:', error.response?.data || error.message);
        throw error;
    }
}